// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1_W4w","content":"LayoutSettings_content__3QqMy"};